module.exports = __webpack_public_path__ + "static/media/Makia1.74e855d2.jpeg";